import TableSolicitudPreagendamientoTecnicoPymes from "@/erp/mantenimiento-operacion/solicitud_tecnico/shared/componente/table_solicitud_tecnico_pymes/TableSolicitudPreagendamientoTecnicoPymes";
import { CustomTabPanel } from "@/erp/sale";
import { a11yProps, ROUTER_PATHS, useTabsFormOnly } from "@/shared";
import { SingleTableBoxScene, SingleBoxTableTabsOnly, FormTabsOnly } from "@/shared/components/ui";
import { Tab } from "@mui/material";

export default function SolicitudTecnicoNocPage() {

  const { handleMethodChange, valueTab } = useTabsFormOnly({});

  return (
    <SingleTableBoxScene title={"Solicitud Técnico NOC"}>
      <SingleBoxTableTabsOnly>
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="Solicitud" value={1} {...a11yProps(1)} />
          {/* <Tab label="Agendamiento" value={2} {...a11yProps(1)} /> */}

        </FormTabsOnly>
      </SingleBoxTableTabsOnly>

      {/* ============ Preagendamientos ============ */}
      <CustomTabPanel value={valueTab} index={1}>
        <TableSolicitudPreagendamientoTecnicoPymes
          provincia_exclude="EC-19"
          router_path={ROUTER_PATHS.noc.solicitudTecnicoNocEditarNav}
        />
      </CustomTabPanel>

      {/* <CustomTabPanel value={valueTab} index={2}>
        <TableSolicitudAgendamientoTecnicoPymes
          //provincia_exclude="EC-19"
          router_path={ROUTER_PATHS.noc.solicitudTecnicoNocAgendaEditarNav}

        />
      </CustomTabPanel> */}

    </SingleTableBoxScene>
  );

}